export default {
  path: 'provider',
  component: () =>
    import('@/views/provider/aee-questionnaire-management/Wrapper.vue'),
  children: [
    {
      path: '/provider/aee-questionnaire',
      name: 'AeeQuestionnaireManagementSearch',
      component: () =>
        import('@/views/provider/aee-questionnaire-management/Search.vue'),
      meta: {
        authorization: {
          requiresAuth: true,
          permissions: ['menu.rempro.provider.aeequestionnaire'],
        },
      },
    },
  ],
};
